// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditPoliticalAffiliation {
    width: 100%;
}

.editPoliticalAffiliationContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.editPoliticalAffiliationCard {
    width: 90%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 14px;
    padding: 22px 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.editPoliticalHeader {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.editPoliticalLabel {
    color: #839696;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    letter-spacing: 0.2px;
}

.politicalSupportPrompt {
    color: #839696;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 400;
}

.politicalDropdownWrapper {
    position: relative;
    width: 100%;
}

.politicalSelectBox {
    background-color: #142424;
    border: 1px solid #233737;
    border-radius: 12px;
    height: 52px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-sizing: border-box;
    transition: all 0.2s ease;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 500;
    width: 100%;
}

.politicalSelectBox:hover {
    border-color: #4DCBCA;
}

.selectedPartyText {
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 500;
}

.placeholderPartyText {
    color: #7A7A7A;
    font-family: "Inter", sans-serif;
    font-size: 15px;
}

.politicalSelectActions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.clearPartyBtn {
    color: #839696;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    border-radius: 50%;
    transition: color 0.15s ease;
}

.clearPartyBtn:hover {
    color: #FF5252;
}

.politicalArrowIcon {
    color: #5AAF9A;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;
}

.politicalSelectBox:hover .politicalArrowIcon {
    color: #4DCBCA;
}

.politicalDropdownMenu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 100%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 12px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);
    list-style: none;
    padding: 8px;
    z-index: 1000;
    max-height: 320px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.politicalSearchBox {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background-color: #142424;
    border: 1px solid #233737;
    border-radius: 8px;
    margin-bottom: 8px;
    transition: border-color 0.2s ease;
}

.politicalSearchBox:focus-within {
    border-color: #5AAF9A;
}

.partySearchInput {
    flex: 1 1;
    background: transparent;
    border: none;
    outline: none;
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 14px;
}

.partySearchInput::placeholder {
    color: #7A7A7A;
}

.partyList {
    list-style: none;
    margin: 0;
    padding: 0;
    overflow-y: auto;
    max-height: 220px;
    scrollbar-width: thin;
    scrollbar-color: #5AAF9A #0E1B1B;
}

.partyItem {
    padding: 10px 14px;
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 14.5px;
    font-weight: 500;
    cursor: pointer;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.15s ease;
    margin: 2px 0;
}

.partyItem:hover {
    background-color: #142424;
    color: #4DCBCA;
}

.partyItem.active {
    background-color: rgba(90, 175, 154, 0.15);
    color: #5AAF9A;
    font-weight: 600;
}

.selectedBadge {
    font-size: 11.5px;
    background-color: #5AAF9A;
    color: #0E1B1B;
    padding: 2px 8px;
    border-radius: 6px;
    font-weight: 600;
}

.noPartiesFound {
    padding: 16px;
    color: #839696;
    font-family: "Inter", sans-serif;
    font-size: 13px;
    text-align: center;
}

.politicalCommunityNotice {
    margin-top: 14px;
    padding: 12px 14px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: all 0.2s ease;
}

.politicalCommunityNotice.notice-info {
    background: rgba(90, 175, 154, 0.08);
    border: 1px solid rgba(90, 175, 154, 0.2);
}

.politicalCommunityNotice.notice-warning {
    background: rgba(245, 158, 11, 0.1);
    border: 1px solid rgba(245, 158, 11, 0.35);
}

.politicalCommunityNotice .noticeIcon {
    font-size: 18px;
    flex-shrink: 0;
}

.politicalCommunityNotice .noticeText {
    font-family: "Inter", sans-serif;
    font-size: 12.5px;
    color: #cbd5e1;
    line-height: 1.45;
}

.politicalCommunityNotice.notice-warning .noticeText {
    color: #fde68a;
}

.politicalCommunityNotice .noticeText strong {
    color: #5AAF9A;
}

.politicalCommunityNotice.notice-warning .noticeText strong {
    color: #fef08a;
}

.editPoliticalSubmitBtnContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    margin-top: 10px;
}

.editPoliticalSubmitBtn {
    width: 100%;
    height: 48px;
    background-color: #5AAF9A;
    color: #0E1B1B;
    border: none;
    border-radius: 12px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);
}

.editPoliticalSubmitBtn:hover:not(:disabled) {
    background-color: #4DCBCA;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);
}

.editPoliticalSubmitBtn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .editPoliticalAffiliationCard,
    .editPoliticalSubmitBtnContainer {
        width: 95%;
        padding: 18px 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/EditPoliticalAffiliation/EditPoliticalAffiliation.css"],"names":[],"mappings":"AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;;QAEI,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n.EditPoliticalAffiliation {\n    width: 100%;\n}\n\n.editPoliticalAffiliationContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.editPoliticalAffiliationCard {\n    width: 90%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 14px;\n    padding: 22px 28px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    box-sizing: border-box;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n.editPoliticalHeader {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.editPoliticalLabel {\n    color: #839696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 500;\n    letter-spacing: 0.2px;\n}\n\n.politicalSupportPrompt {\n    color: #839696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 400;\n}\n\n.politicalDropdownWrapper {\n    position: relative;\n    width: 100%;\n}\n\n.politicalSelectBox {\n    background-color: #142424;\n    border: 1px solid #233737;\n    border-radius: 12px;\n    height: 52px;\n    padding: 0 16px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    box-sizing: border-box;\n    transition: all 0.2s ease;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n    width: 100%;\n}\n\n.politicalSelectBox:hover {\n    border-color: #4DCBCA;\n}\n\n.selectedPartyText {\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.placeholderPartyText {\n    color: #7A7A7A;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n}\n\n.politicalSelectActions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.clearPartyBtn {\n    color: #839696;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px;\n    border-radius: 50%;\n    transition: color 0.15s ease;\n}\n\n.clearPartyBtn:hover {\n    color: #FF5252;\n}\n\n.politicalArrowIcon {\n    color: #5AAF9A;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s ease;\n}\n\n.politicalSelectBox:hover .politicalArrowIcon {\n    color: #4DCBCA;\n}\n\n.politicalDropdownMenu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    width: 100%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 12px;\n    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);\n    list-style: none;\n    padding: 8px;\n    z-index: 1000;\n    max-height: 320px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n}\n\n.politicalSearchBox {\n    display: flex;\n    align-items: center;\n    padding: 8px 12px;\n    background-color: #142424;\n    border: 1px solid #233737;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    transition: border-color 0.2s ease;\n}\n\n.politicalSearchBox:focus-within {\n    border-color: #5AAF9A;\n}\n\n.partySearchInput {\n    flex: 1;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n}\n\n.partySearchInput::placeholder {\n    color: #7A7A7A;\n}\n\n.partyList {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    overflow-y: auto;\n    max-height: 220px;\n    scrollbar-width: thin;\n    scrollbar-color: #5AAF9A #0E1B1B;\n}\n\n.partyItem {\n    padding: 10px 14px;\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14.5px;\n    font-weight: 500;\n    cursor: pointer;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    transition: all 0.15s ease;\n    margin: 2px 0;\n}\n\n.partyItem:hover {\n    background-color: #142424;\n    color: #4DCBCA;\n}\n\n.partyItem.active {\n    background-color: rgba(90, 175, 154, 0.15);\n    color: #5AAF9A;\n    font-weight: 600;\n}\n\n.selectedBadge {\n    font-size: 11.5px;\n    background-color: #5AAF9A;\n    color: #0E1B1B;\n    padding: 2px 8px;\n    border-radius: 6px;\n    font-weight: 600;\n}\n\n.noPartiesFound {\n    padding: 16px;\n    color: #839696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13px;\n    text-align: center;\n}\n\n.politicalCommunityNotice {\n    margin-top: 14px;\n    padding: 12px 14px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    transition: all 0.2s ease;\n}\n\n.politicalCommunityNotice.notice-info {\n    background: rgba(90, 175, 154, 0.08);\n    border: 1px solid rgba(90, 175, 154, 0.2);\n}\n\n.politicalCommunityNotice.notice-warning {\n    background: rgba(245, 158, 11, 0.1);\n    border: 1px solid rgba(245, 158, 11, 0.35);\n}\n\n.politicalCommunityNotice .noticeIcon {\n    font-size: 18px;\n    flex-shrink: 0;\n}\n\n.politicalCommunityNotice .noticeText {\n    font-family: \"Inter\", sans-serif;\n    font-size: 12.5px;\n    color: #cbd5e1;\n    line-height: 1.45;\n}\n\n.politicalCommunityNotice.notice-warning .noticeText {\n    color: #fde68a;\n}\n\n.politicalCommunityNotice .noticeText strong {\n    color: #5AAF9A;\n}\n\n.politicalCommunityNotice.notice-warning .noticeText strong {\n    color: #fef08a;\n}\n\n.editPoliticalSubmitBtnContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.editPoliticalSubmitBtn {\n    width: 100%;\n    height: 48px;\n    background-color: #5AAF9A;\n    color: #0E1B1B;\n    border: none;\n    border-radius: 12px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);\n}\n\n.editPoliticalSubmitBtn:hover:not(:disabled) {\n    background-color: #4DCBCA;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);\n}\n\n.editPoliticalSubmitBtn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n    .editPoliticalAffiliationCard,\n    .editPoliticalSubmitBtnContainer {\n        width: 95%;\n        padding: 18px 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
